<template>
  <a-col>
    <div type="flex" justify="center" align="center" class="provisioning_tips_container">
      <p v-if="!isCountDownEnd" class="provisioning_code_tips">{{ countDownNum }}秒後重新寄送</p>
      <p v-else>未收到驗證碼？
        <a class="provisioning_hyperlink" @click.prevent="handleResendVerificationCode">重新寄送</a>
      </p>
    </div>
    <div>
      <a-button block class="green_bg step_btn" size="large" @click="verifyCode" :disabled="isLoading"><span>驗證 </span></a-button>
    </div>
    <div type="flex" justify="center" align="center" class="error_phone_tips">
      <p>若您的手機號碼有誤，請回 <a class="provisioning_hyperlink" @click.prevent="backToPrePage">上一步</a> 修改</p>
    </div>
  </a-col>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import {bus} from "../../main";
import {mixinSendSmsMethods} from "../../utils/mixins";

export default {
  name: 'ProvisioningVerifyButton',
  mixins: [mixinSendSmsMethods],
  data() {
    return {
      isLoading: false,
      countDownNum: 60,
      isCountDownEnd: false,
      timerFunc: null,
      currentCodeArr: [
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        }
      ],
      msgObj: {
        visible: false,
        title: '驗證錯誤',
        okText: '確認',
        cancelText: '',
        detailText: '',
        msgClass: 'msg_confirm_modal',
      },
    }
  },
  created() {
    bus.$on("passCurrentCode", data => {
      console.log('data', data);
      this.currentCodeArr = data;
    });
  },
  mounted() {
    this.timerFunc = setInterval(this.handleCountdown, 1000);
  },
  methods: {
    ...mapActions('identidyOpenResult', ['identidyResultAction']),
    handleCountdown() {
      this.countDownNum--;
      if (this.countDownNum === 0) {
        clearInterval(this.timerFunc);
        this.countDownNum = 60;
        this.isCountDownEnd = true;
      }
    },
    handleResendVerificationCode() {
      this.isCountDownEnd = false;
      this.timerFunc = setInterval(this.handleCountdown, 1000);

      const { name, carNo } = this.identidyInfo;

      const params = {
        name,
        carNo,
        phoneNum: this.withoutDashPhoneNumber,
        // openedName: name,
        // openedMobile: this.withoutDashPhoneNumber,
        // deviceUid: this.deviceUid,
      };
      this.sendSmsToPhone(params);
    },
    verifyCode() {
      console.log('currentCodeArr', this.currentCodeArr);
      const emptyCode = this.currentCodeArr.find(code => !code.value);
      if (emptyCode) {
        bus.$emit('emptyCode', true);
        bus.$emit('errorCode', false);
        return;
      } else {
        // 開通
        bus.$emit('emptyCode', false);
        let numStr = '';
        this.currentCodeArr.forEach(element => {
          numStr += element.value.toString()
        });
        const {name, carNo} = this.identidyInfo;

        const params = {
          phoneNum: this.withoutDashPhoneNumber,
          name,
          carNo: carNo,
          smsUid: this.smsUid,
          otpCode: numStr,
          encodedImei: this.deviceUid
        }

        // const params = {
        //   deviceUid: this.deviceUid,
        //   smsUid: this.smsUid,
        //   validationCode: numStr,
        //   carNo: carNo,
        //   openedUser: name,
        //   openedMobile: this.withoutDashPhoneNumber,
        // }

        this.openDevice(params);
      }
    },
    backToPrePage() {
      this.$router.go(-1);
    },
    async openDevice(params) {
      this.setLoadingState(true);
      try {
        const result = await this.identidyResultAction(params);
        const deviceUid = this.$route.query.data || '';

        if (result.status === 200) {
          bus.$emit('errorCode', false);
          console.log('step4 deviceUid:', deviceUid)
          this.setLoadingState(false);
          await this.$router.push(`/provisioning/step4?data=${encodeURIComponent(deviceUid)}`);
        }
      } catch (errorStatus) {
        // console.log('errorStatus',errorStatus);
        bus.$emit('errorCode', true);
        this.getErrMsg(errorStatus);
        this.$emit('responseStatus', this.msgObj);
        this.setLoadingState(false);
      }
    },
    getErrMsg(status) {
      switch (status) {
          // 3:設備不存在、4:設備停用
        case 3:
        case 4:
          this.msgObj = {
            ...this.msgObj,
            visible: true,
            title: '裝置不存在',
            okText: '撥打電話',
            cancelText: '否',
            detailText: '查無此裝置資訊，請聯繫客服人員',
            msgClass: 'msg_error_modal',
          };
          break;
        case 5:
          this.msgObj = {
            ...this.msgObj,
            detailText: '簡訊已過期',
            visible: true,
            msgClass: 'msg_confirm_modal'
          };
          break;
        case 7:
          this.msgObj = {
            ...this.msgObj,
            detailText: '設備已開通',
            visible: true,
            msgClass: 'msg_confirm_modal'
          };
          break;
        default:
          break;
      }
    },
    setLoadingState(isLoading) {
      this.isLoading = isLoading;
      this.$emit('loading', isLoading);
    }
  },
  computed: {
    ...mapState('identidyOpenStatus', ['deviceUid']),
    ...mapState('identidyInfo', ['identidyInfo']),
    ...mapState('identidySms', ['smsUid']),
    ...mapGetters('identidyInfo', ['withoutDashPhoneNumber']),
  },
  beforeDestroy() {
    clearInterval(this.timerFunc);
  }
}
</script>

<style lang="scss" scoped>
.provisioning_tips_container {
  margin: 27px auto;

  .provisioning_code_tips {
    color: rgba(0, 0, 0, 0.25);
  }
}

.provisioning_hyperlink {
  color: #7CB305;
}

.error_phone_tips {
  margin-top: 15px;
  color: #343741;
}
</style>
